// Use Map to store data in Memory Cache

const MemoryCache = new Map();
export default MemoryCache;

interface Expirable<T> {
  expireAfter: number;
  createTime: number;
  data: T;
}

export const withCache = async <T extends object>(
  key: string,
  expireAfter: number,
  getFunc: () => Promise<T>
): Promise<T> => {
  let cachedData = MemoryCache.get(key) as Expirable<T>;

  if (!cachedData || cachedData.createTime + expireAfter < Date.now()) {
    const data = await getFunc();
    cachedData = {
      expireAfter: expireAfter,
      createTime: Date.now(),
      data: data,
    };
    MemoryCache.set(key, cachedData);
  }

  return cachedData.data;
};
